var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"chip-text-primary",attrs:{"small":"","outlined":""},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('v-icon',{staticClass:"mr-2",class:{
      'rotate-180': _vm.value
    }},[_vm._v(" expand_more ")]),_vm._v(" "+_vm._s(_vm.$t(`article.extendWithAi.${_vm.langPath}.toggle`))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }